import { ApiResponse } from '@vision/ui/interfaces';
import { createHttpExtraOptions } from '../../../utils';
import { TicketManagerApi } from '../ticket-manager.api';
import { TicketManagerPickNextTicketResponse, TicketManagerQueuePickNextArgs } from './pick-next.api.types';
import { buildPickNextQueueTicketRequest } from './pick-next.routes';

export const TicketPickNextEndpoints = TicketManagerApi.injectEndpoints({
  endpoints: (builder) => ({
    pickNextTicketManagerQueue: builder.mutation<
      ApiResponse<TicketManagerPickNextTicketResponse>,
      TicketManagerQueuePickNextArgs
    >({
      query: ({ projectId, queueId, userId }) => ({
        ...buildPickNextQueueTicketRequest({ projectId, queueId, userId }),
        extraOptions: createHttpExtraOptions({
          notification: {
            autoHandleError: false,
          },
        }),
      }),
      invalidatesTags: (_result, error, { queueId }) =>
        error ? [] : [{ type: 'TicketManagerQueueTickets', id: queueId }],
    }),
  }),
});

export const { usePickNextTicketManagerQueueMutation } = TicketPickNextEndpoints;
